import axios from "axios";
import { config } from "../brandConfig";

export const identityApi = axios.create({
	baseURL: config.identityAPIBaseURL,
});
